<template>
    <nt-template>
      <v-row desne justify="center">
        <v-col cols="12" md="4" class="wrapper-tree-content">
          <nt-tree-view :currentLessonId="aulaId" :model="treeData"/>
        </v-col>
        <v-col cols="12" md="8" class="wrapper-lesson-content">
          <div class="mb-3 py-2 text-center">
            {{ topicoAula.join('  &raquo;  ') }}
          </div>
          <router-view></router-view>
        </v-col>
      </v-row>
    </nt-template>
</template>

<script>
import NtTemplate from '@/components/Utils/NtTemplate'
import NtTreeView from '@/components/Utils/NtTreeView/Index.vue'
import { mapGetters } from 'vuex'

export default {
  mounted: function () {
    this.carregaDadosMatricula()
  },
  components: {
    NtTemplate,
    NtTreeView
  },
  props: ['matriculaId', 'aulaId'],
  beforeRouteLeave (to, from, next) {
    this.$destroy()
    next()
  },
  beforeDestroy () {
    this.$store.commit('SalaDeAula/setTreeData', [])
  },
  watch: {
    $route: function () { this.initTreeData() }
  },
  methods: {
    carregaDadosMatricula () {
      this.$store.dispatch('SalaDeAula/initSalaDeAula', { enrollmentId: this.matriculaId, lessonId: this.aulaId })
        .then(response => {
          if (this.$route.name === 'salaDeAula') {
            this.$router.replace({ name: 'salaDeAula.aula', params: { matriculaId: this.matriculaId, aulaId: response.data.currentLesson } })
          }
        })
        .catch(responseError => {
          if (responseError.status === 404) {
            this.$toasted.global.error({ message: responseError.data.message })
            this.$router.replace({ name: 'ambienteAluno.course.index' })
          } else {
            this.$toasted.global.error({ message: 'Erro ao carregar dados do curso.' })
          }
        })
    },
    initTreeData () {
      this.$store.commit('SalaDeAula/updateActiveLesson', this.aulaId)
    }
  },
  computed: {
    ...mapGetters({
      treeData: 'SalaDeAula/enrollmentTreeData',
      topicoAula: 'SalaDeAula/breadcrumbLessonTopic'
    })
  }
}
</script>

<style lang="css">
@media screen and (min-width: 960px) {
  .wrapper-tree-content,
  .wrapper-lesson-content {
    height: calc(100vh - 156px);
    overflow: auto;
  }
}
</style>
